import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr7 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа с пробивна машина (бормашина)
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1 .До работа с пробивна машина </b>(бормашина) се допускат само лица, които са преминали
        съответното обучение и инструктаж за безопасна работа.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2 . При работа задължително да се използват </b>одобрените и предоста- вени съобразно
        степента на риска лични предпазни средства, за вида, употребата и начина на съхранение, на
        които работещите са инструктира- ни (и обучени за използването на тези ЛПС, за които това е
        необходимо).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3 .<span style={styles.warning}>Забранява се </span>
        </b>
        работа с неизправни лични предпазни средства и с такива с изтекъл срок на годност и на
        периодична проверка.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4 .Преди започване на работа техникът </b>трябва да провери: изправ- ността на машината,
        (като направи външен оглед и я пусне на празен ход); наличието и изправността на предпазните
        средства (блокировки).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          5 .<span style={styles.warning}>Забранено е </span>
        </b>
        да се работи с бормашина, която има необезопасени движещи се части.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6 .Задължително да се работи със </b>закопчано и прибрано до тялото работно облекло.
      </Typography>

      <Typography>
        /.Свредлото (бургията) да се поставя правилно, като се центрова и се стегне здраво в
        патронника с принадлежащите към комплекта инстру- менти.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          7 .<span style={styles.warning}>Забранено е </span>
        </b>
        поставянето на свредлото или патронника, когато бормашината е в движение.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>8 . Пробиването да става с равномерен натиск </b>на режещия инструмент.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9 .Работещият с бормашината трябва </b>да следи непрекъснато за правилния ход и за
        правилното въртене на свредлото при пробиване.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10 .Механизмът за закрепване на патронника </b>да действа сигурно, да предотвратява
        изпадането и да позволява точно центроване.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11 . Почистването на стружките </b>да се извършва с кука, с малка метличка и др.
        приспособления. Забранено е почистването на стружките с ръка.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          12 . <span style={styles.warning}>Забранено е </span>
        </b>
        охлаждането на режещия инструмент с намокрени конци и парцали.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          13 . <span style={styles.warning}>Забранено е </span>
        </b>
        почистване, смазване и ремонтиране на бормашината в движение.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          14 . <span style={styles.warning}>Забранено е </span>
        </b>
        ползването на ръкавици, когато бормашината е в движение.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>15 . След завършване на работата бормашината</b> да се спира от движение и се изключва от
        електрозахранването.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          16 . <span style={styles.warning}>Забранено е </span>
        </b>
        ползването на сгъстен въздух за почистване на направените отвори, бормашината, облеклото и
        работното място.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr7;
